import React from "react";
import { GiFairyWings } from "react-icons/gi";
import { Helmet } from "react-helmet-async";
import "./AboutConstitution.css";

const AboutConstitution = () => {
  return (
      <>
      <Helmet>
        <title>Constitution / Deed | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Learn more about the constitution and deed of Rajput Shiksha Kosh."
        />
      </Helmet>
    <section className="about-constitution-deed-wrapper">
      {/* --- CENTER HEADER --- */}
      <div className="about-constitution-deed-header">
        <h2 className="about-constitution-deed-title">CONSTITUTION / DEED</h2>
        <div className="about-constitution-deed-divider">
          <span className="about-constitution-deed-line"></span>
          <GiFairyWings className="about-constitution-deed-icon" />
          <span className="about-constitution-deed-line"></span>
        </div>
      </div>

      {/* --- MAIN CONTAINER --- */}
      <div className="about-constitution-deed-container">
        <div className="about-constitution-deed-main-box">
          {/* --- PREAMBLE --- */}
          <p className="about-constitution-deed-preamble">
            हम निम्नलिखित व्यक्ति, समाज के अभावग्रस्त तथा प्रतिभावान बालकों की शिक्षा अथवा अध्यन्न को सुनिश्चित करने हेतु ऐसे बालकों को छात्रवृतियां अथवा आर्थिक सहयोग की प्रक्रिया को सतत, निरंतर एवं नियमित स्वरुप देने हेतु एक ट्रस्ट का निर्माण एवं गठन करने की मनोभावना से प्रेरित होकर हमारे नाम के आगें लिखी रकम देकर अपनी इच्छा से राजपूत शिक्षा कोष के रूप में जन हितार्थ एवं जन सेवार्थ सार्वजनिक ट्रस्ट के गठन की घोषणा करते है | जिन्हें संस्थापक ट्रस्टी कहा जावेगा |
          </p>

          {/* --- FOUNDER TRUSTEES LIST --- */}
          <div className="about-constitution-deed-trustee-list">
            <div className="about-constitution-deed-trustee-item">
              <span>१. ठाकुर ओंकारसिंह जी बाबरा I. A.S. (Retd.)</span>
              <span className="amount">5,00,000/-</span>
            </div>
            <div className="about-constitution-deed-trustee-item">
              <span>२. कर्नल शिवसिंह जी (सेनणी)</span>
              <span className="amount">1,00,000/-</span>
            </div>
            <div className="about-constitution-deed-trustee-item">
              <span>३. कर्नल उम्मेदसिंह जी राठौड़ (गुनावटी )</span>
              <span className="amount">1,00,000/-</span>
            </div>
            <div className="about-constitution-deed-trustee-item">
              <span>४. डॉ. नारायणसिंह जी माणकलाव</span>
              <span className="amount">2,51,000/-</span>
            </div>
          </div>

          {/* --- IMPORTANT STATEMENT --- */}
          <div className="about-constitution-deed-statement">
            <p>
              उक्त रकम हमारे द्धारा मनोनीत ट्रस्टियों द्धारा गठित ट्रस्ट को इस आधार पर सौंपते है कि किसी भी परिस्थिति में, किन्हीं भी पदाधिकारियों द्धारा इस <strong>स्थाई कोष से एक रुपया भी नहीं निकाला जावेगा</strong> तथा इस बीज राशि को आधार मानकर एक विशाल कोष एकत्रित करके ट्रस्ट के उद्देश्यों की पूर्ति हेतु सद्प्रयास किया जावेगा |
            </p>
          </div>

          {/* --- TRUST STATUTES --- */}
          <div className="about-constitution-deed-statutes">
            <h3 className="about-constitution-deed-statute-title">ट्रस्ट की अन्य सूचनाएं एवं विधान निम्न प्रकार होगा :-</h3>
            
            <div className="about-constitution-deed-statute-item">
              <span className="point-number">1.</span>
              <p><strong>ट्रस्ट का नाम :</strong> राजपूत शिक्षा कोष</p>
            </div>

            <div className="about-constitution-deed-statute-item">
              <span className="point-number">2.</span>
              <p><strong>ट्रस्ट का कार्यालय :</strong> राजपूत शिक्षा कोष c/o मारवाड़ राजपूत सभा भवन, पावटा बी रोड़, जोधपुर (राज.)</p>
            </div>

            <div className="about-constitution-deed-statute-item">
              <span className="point-number">3.</span>
              <div className="statute-content">
                <strong>ट्रस्ट के उद्देश्य :-</strong>
                <p>(1.) माध्यमिक शिक्षा एवं उच्च शिक्षा हेतु प्रतिभावान एवं जरूरतमंद विद्यार्थियों को छात्रवृत्तियो प्रदान करना एवं Education Loan देना|</p>
                <p>(2.) शिक्षा के क्षेत्र में अनुसंधान करना, उसको प्रकाशित करना तथा जर्नल्स, बुलेटिन एवं अनुसंधान पत्रों, पुस्तकों, ऑडियो वीडियो का निर्माण व वितरण करना|</p>
              </div>
            </div>

            <div className="about-constitution-deed-statute-item">
              <span className="point-number">4.</span>
              <div className="statute-content">
                <strong>कार्यप्रणाली :-</strong>
                <p>(1.) इस ट्रस्ट का सारा कार्यभार ट्रस्टियों के जिम्मे रहेगा | ट्रस्ट की साधारण सभा अपने में से ट्रस्ट की 9 सदस्यीय प्रबंधकारिणी समिति का बहुमत से चुनाव करेगी | जो निम्न प्रकार होगी :- अध्यक्ष - (1), उपाध्यक्ष -(1), कोषाध्यक्ष -(1), सचिव -(1), सदस्य -(5)</p>
                <p>(2.) ट्रस्ट की एक कैलेंडर वर्ष में 2 बैठके करना अनिवार्य होगी |</p>
                <p>(3.) ट्रस्ट की बैठके प्रबंधकारिणी समिति के अध्यक्ष के आदेश से सचिव द्धारा आहूत की जावेगी | साधारण सभा के बैठक का नोटिस 15 दिन पूर्व देना आवश्य्क होगा | विशेष परिस्थितियों में अध्यक्ष को 07 दिन में विशेष बैठक बुलाने का अधिकार होगा तथा कभी भी 10 ट्रस्टियों के आग्रह पर साधारण सभा आहूत करना अनिवार्य होगा |</p>
                <p>(4.) ट्रस्ट की साधारण सभा की बैठक में 10 सदस्यों का कोरम होगा | ट्रस्टी पूर्णरूपेण अवैतनिक सेवा देंगे | प्रत्यक्ष एवं अप्रत्यक्ष रूप से ट्रस्ट से किसी तरह की व्यक्तिगत लाभ नहीं उठायेंगे |</p>
                <p>(5.) ट्रस्टियों की नियुक्ति आजीवन होगी किसी ट्रस्टी के त्यागपत्र देने, स्वर्गवास होने तथा किसी अन्य कारणवश स्थान रिक्त होने पर ट्रस्टीगण किसी भी योग्य व्यक्ति का चयन बहुमत के आधार पर कर सकेंगे | ट्रस्टियों की अधिकतम संख्या 31 होगी |</p>
                <p>(6.) ट्रस्ट के स्थाई कोष एवं उससे प्राप्त दान -अनुदान के रूप में मिलनें वाली रकम स्थाई कोष में ही जमा होगी तथा ब्याज अथवा लाभांश को ही ट्रस्ट के उद्देश्यों निमित खर्च किया जा सकेगा |</p>
                <p>(7.) स्थाई कोष से ब्याज एवं लाभांश प्राप्त करने हेतु स्थाई फण्ड को या उसके किसी हिस्से को यथोचित बैंको तथा अन्य संस्थानों में विनियोग करने के प्रबंध कारिणी समिति के प्रस्ताव पर विचार कर अनुमोदन करने का अधिकार साधारण सभा का होगा |</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutConstitution;